module.exports = __webpack_public_path__ + "img/1521187783.fb21f338.jpg";